import config from "../../config.js";

export const createParentVehicleStream = (deviceId) =>
  new EventSource(`${config.baseURL}/redis/stream?vehicleId=${deviceId}`);

export const fetchLatestVehiclePosition = async (deviceId) => {
  const response = await fetch(`${config.baseURL}/location/latest/${deviceId}`);

  if (!response.ok) {
    throw new Error(
      `Failed to fetch latest vehicle position: ${response.status}`,
    );
  }

  return response.json();
};

export const requestParentRouteDirections = ({
  googleMaps,
  origin,
  destination,
  waypoints = [],
}) =>
  new Promise((resolve, reject) => {
    const directionsService = new googleMaps.DirectionsService();

    directionsService.route(
      {
        origin,
        destination,
        waypoints,
        optimizeWaypoints: false,
        travelMode: googleMaps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === googleMaps.DirectionsStatus.OK) {
          resolve(result);
          return;
        }

        reject(new Error(`Directions API error: ${status}`));
      },
    );
  });
